import React from 'react';

const authenticatedLoginContext = React.createContext({
  username: 'unidentified human',
  admin: null
});

export { authenticatedLoginContext }
